import { Column } from 'react-table';

import { phoneObjToString } from './helpers';

export const settlementTeamColumns: Array<Column> = [
  {
    id: 'Type',
    Header: 'Type',
    accessor: (row: any) => row.Type,
  },
  {
    id: 'CompanyName',
    Header: 'Company',
    accessor: (row: any) => row.CompanyName,
  },
  {
    id: 'FirstName',
    Header: 'First',
    accessor: (row: any) => row.FirstName,
  },
  {
    id: 'LastName',
    Header: 'Last',
    accessor: (row: any) => row.LastName,
  },
  {
    id: 'PhoneNumbers',
    Header: 'Phone',
    accessor: (row: any) => {
      row.PhoneNumbers && row.PhoneNumbers.length > 0
        ? phoneObjToString(row.PhoneNumbers[0])
        : '';
    },
    Cell: (data: any) =>
      data.row.original.PhoneNumbers &&
      data.row.original.PhoneNumbers.length > 0
        ? phoneObjToString(data.row.original.PhoneNumbers[0])
        : '',
  },
  {
    id: 'Emails',
    Header: 'Email',
    accessor: (row: any) =>
      row.Emails && row.Emails.length > 0 ? row.Emails[0] : '',
  },
];
